const threadSource = {
  OPPORTUNITY: 'opportunity',
  CUSTOM_THREAD: 'customThread',
  SWEETHEART_LIST: 'sweetheartList',
};

export default threadSource;
